import dayjs from "dayjs";

export const getUtcEpoch = (date: string) => {
  const newDate = dayjs.utc(date);
  return newDate.unix();
};
